import * as apiUtils from "../_api/apiUtils";

const baseUrl = "https://maps.googleapis.com/maps/api/geocode/json?address=";

export const geocoderService = {
  getAddressInfo,
};

function getAddressInfo(Address) {
  return apiUtils
    .get(
      `${baseUrl}${Address}&key=${process.env.REACT_APP_GOOGLE_KEY}&libraries=places,marker&loading=async&callback=Function.prototype`
    )
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}
